import React from 'react'

type FilterType = 'all' | 'active' | 'completed'

interface TodoFilterProps {
  currentFilter: FilterType
  onFilterChange: (filter: FilterType) => void
}

const TodoFilter: React.FC<TodoFilterProps> = ({ currentFilter, onFilterChange }) => {
  return (
    <div className="filters">
      <button 
        className={`filter-btn ${currentFilter === 'all' ? 'active' : ''}`} 
        onClick={() => onFilterChange('all')}
      >
        All
      </button>
      <button 
        className={`filter-btn ${currentFilter === 'active' ? 'active' : ''}`} 
        onClick={() => onFilterChange('active')}
      >
        Active
      </button>
      <button 
        className={`filter-btn ${currentFilter === 'completed' ? 'active' : ''}`} 
        onClick={() => onFilterChange('completed')}
      >
        Completed
      </button>
    </div>
  )
}

export default TodoFilter 